import React, { useRef, useEffect, useState } from "react";
import useResizeChart from "./hooks/UseResizeChart";

const Chart = ({ data, chartType, isHorizontal, scale, selection, view, measure, deathType, period }) => {
    const svgRef = useRef();
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const handleResize = () => {
            const width = svgRef.current.parentElement.clientWidth;
            const height = svgRef.current.parentElement.clientHeight;
            setDimensions({ width, height });
        };

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [selection]);

    useResizeChart(svgRef, data, dimensions, chartType, isHorizontal, scale, selection, view, measure, deathType, period);

    return (
        <svg ref={svgRef} style={{ width: '100%', height: 'auto', minHeight: '60vh' }} />
    );
};

export default Chart;